import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { fontWeight, textColor } from '../../theming';
import { mutedSmallStyle } from './vinExtractionStyles';
import NoValue from './NoValue';

const CarStockCell = ({ car }) => {
    const { t } = useTranslation('vinExtraction');

    return (
        <Flex vertical>
            <span style={{ fontWeight: fontWeight.xl, color: textColor.primary }}>
                {car.stockNumber ?? <NoValue label={t('cars.noStockNo')} />}
            </span>
            <span style={mutedSmallStyle}>{t('cars.carId', { id: car.carId })}</span>
        </Flex>
    );
};

export default CarStockCell;
